// Combat FX overlay — floating damage numbers + hit flash + kill glow.
// Listens to ServerMsg directly (combat/killed/died) and renders ephemeral DOM nodes.

import type { Net } from "../net.js";
import type { ServerMsg } from "../../shared/protocol.js";

export function mountFx(host: HTMLElement, net: Net): void {
  // host already exists in DOM; we only attach handlers.
  net.on((msg: ServerMsg) => {
    switch (msg.t) {
      case "combat": {
        const r = msg.round;
        if (r.attacker_dmg > 0 && r.mob_hp >= 0) {
          spawnFloat(host, `-${r.attacker_dmg}`, "outgoing");
        }
        if (r.mob_dmg > 0) {
          spawnFloat(host, `-${r.mob_dmg}`, "incoming");
          flash(host, "red");
        }
        break;
      }
      case "killed":
        spawnFloat(host, `+${msg.xp_gained} xp`, "xp");
        flash(host, "gold");
        break;
      case "died":
        flash(host, "death");
        spawnFloat(host, "DEFEATED", "death");
        break;
    }
  });
}

function spawnFloat(host: HTMLElement, text: string, kind: "outgoing" | "incoming" | "xp" | "death"): void {
  const el = document.createElement("div");
  el.className = `fx-float fx-${kind}`;
  el.textContent = text;
  // Random horizontal offset around centre.
  el.style.left = `calc(50% + ${(Math.random() - 0.5) * 200}px)`;
  host.appendChild(el);
  setTimeout(() => el.remove(), 1400);
}

function flash(host: HTMLElement, kind: "red" | "gold" | "death"): void {
  const el = document.createElement("div");
  el.className = `fx-flash fx-flash-${kind}`;
  host.appendChild(el);
  setTimeout(() => el.remove(), kind === "death" ? 1500 : 600);
}
